<template>
	<v-app
		id="app"
	>
		<template v-if="isUserLoggedIn">
			<v-app-bar
				color="#1FC3F0"
				clipped-left
				dense
				fixed
				app
			>
				<v-app-bar-nav-icon
					@click.stop="drawer = !drawer"
					v-if="['login'].indexOf($route.name) === -1"
				></v-app-bar-nav-icon>
				<v-toolbar-title>Porovnávač zájezdů</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-tooltip left>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							icon
							@click="logout"
							v-bind="attrs"
							v-on="on"
						>
							<v-icon>mdi-logout</v-icon>
						</v-btn>
					</template>
					<span>Odhlášení</span>
                </v-tooltip>
			</v-app-bar>
			<v-navigation-drawer
				v-if="['login'].indexOf($route.name) === -1"
				v-model="drawer"
				width="auto"
				clipped
				app
			>
				<v-list-group
					v-for="(page, i) in pages"
					:key="i"
					:prepend-icon="page.icon"
				>
					<template
						v-slot:activator
					>
						<v-list-item-title>{{ page.title }}</v-list-item-title>
					</template>
					<v-list-item
						v-for="(subPage, y) in page.subPages"
						:prepend-icon="page.icon"
						:key="y"
						link
						:to="subPage.route"
					>
						<v-list-item-icon>
							<v-icon>{{ subPage.icon }}</v-icon>
						</v-list-item-icon>
						<v-list-item-title>{{ subPage.title }}</v-list-item-title>
					</v-list-item>
				</v-list-group>
				<v-list nav>
					<v-list-item
						link
						:to="singleItem.route"
					>
						<v-list-item-icon>
							<v-icon>{{ singleItem.icon }}</v-icon>
						</v-list-item-icon>

						<v-list-item-content>
							<v-list-item-title>{{ singleItem.title }}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</v-navigation-drawer>
		</template>
		<v-main>
			<v-container
				fluid
			>
				<v-row
					align="center"
					justify="center"
				>
					<v-col>
						<router-view
							:key="$route.fullPath"
						></router-view>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
		<v-footer
			v-if="isUserLoggedIn"
			app
			dense
			padless
			color="#1FC3F0"
		>
			<v-col
				class="text-left"
				cols="12"
			>
				© {{ new Date().getFullYear() }} — <strong>Václav Kirchner</strong>
			</v-col>
		</v-footer>
	</v-app>
</template>

<script>
import LOGIN_MUTATION from  './graphql/loginMutation.gql';

export default {
	name: "App",
	data: () => ({
		drawer: null,
		pages: [
			{ title: 'Lokality', icon: 'map', route: 'localityStandard', subPages: [
				{ title: 'Stadard', icon: 'star', route: 'localityStandard'},
				{ title: 'Pravidla', icon: 'rule', route: 'localityRules'}
			]},
			{ title: 'Odjezdová místa', icon: 'mdi-plane-train', route: 'transportPlaceStandard', subPages: [
				{ title: 'Stadard', icon: 'star', route: 'transportStandardPlace'},
				{ title: 'Pravidla', icon: 'rule', route: 'transportRulesPlace'}
			]},
			{ title: 'Slevy', icon: 'mdi-percent', route: 'discountStandard', subPages: [
				{ title: 'Stadard', icon: 'star', route: 'discountStandard'},
				{ title: 'Pravidla', icon: 'rule', route: 'discountRules'}
			]},
			{ title: 'Strava', icon: 'mdi-silverware-fork-knife', route: 'boardTypeStandard', subPages: [
				{ title: 'Stadard', icon: 'star', route: 'boardTypeStandard'},
				{ title: 'Pravidla', icon: 'rule', route: 'boardTypeRules'}
			]},
			{ title: 'Typy zájezdů', icon: 'mdi-format-list-bulleted-type', route: 'tourTypeStandard', subPages: [
				{ title: 'Stadard', icon: 'star', route: 'tourTypeStandard'},
				{ title: 'Pravidla', icon: 'rule', route: 'tourTypeRules'}
			]},
			{ title: 'Štítky', icon: 'mdi-tag-multiple', route: 'tagStandard', subPages: [
				{ title: 'Typy', icon: 'mdi-format-list-bulleted-type', route: 'tagTypeStandard'},
				{ title: 'Stadard', icon: 'star', route: 'tagStandard'},
				{ title: 'Pravidla', icon: 'rule', route: 'tagRules'}
			]}
		],
		singleItem: { title: 'Zájezdy', icon: 'mdi-umbrella-beach', route: 'tours'}
	}),

	computed: {
        isUserLoggedIn() {
            // Reactive state check
            return this.$route.name !== 'login' && sessionStorage.getItem('is_auth') === 'true';
        }
    },

	methods: {
		navigateTo(route) {
			if (this.$route.name !== route) {
				this.$router.push({ name: route }).catch((error) => {
					console.log(error);
				});
			}
		},
		logout() {
			this.$apollo.mutate({
				mutation: LOGIN_MUTATION,
				variables: {
					name: '',
					password: '',
					logout: true
				}
			}).then(() => {}).catch((error) => {
				console.error(error);
				this.snackbar.text = 'Neúspěšné odhlášení';
				this.snackbar.active = true;
			}).finally(() => {
				sessionStorage.removeItem('is_auth');
				if (this.$route.name !== 'login') {
					this.$router.push({ name: 'login' });
				}
				// Reset Apollo cache (force to remove cached items)
				this.$apollo.getClient().resetStore();
			});
		},
	},
}
</script>